import { observer } from 'mobx-react';
import { FC } from 'react';
import { OrderNotesToggle } from '../../components/OrderNotesToggle/OrderNotesToggle';
import { orderConfigurationStore } from '../../store/orderConfigurationStore';
import './style.scss';

export const OrderNotesSwitchers: FC = observer((): JSX.Element => {
  const { changeOrderNotes } = orderConfigurationStore;

  return (
    <div className="order-notes-switchers" style={{ maxHeight: orderConfigurationStore.orderSettings.isCheckout ? 300 : 500 }}>
      <OrderNotesToggle
        title="order_notes"
        status={orderConfigurationStore.orderSettings.notes.allowNotesAtCheckout}
        label="order_notes_control"
        onChange={(status) => changeOrderNotes({ allowNotesAtCheckout: status })}
      />
      <OrderNotesToggle
        title="item_notes"
        status={orderConfigurationStore.orderSettings.notes.allowItemNotes}
        label="item_notes_control"
        onChange={(status) => changeOrderNotes({ allowItemNotes: status })}
      />
      <OrderNotesToggle
        title="order_for_sb"
        status={orderConfigurationStore.orderSettings.notes.allowOrderForElse}
        label="enable"
        onChange={(status) => changeOrderNotes({ allowOrderForElse: status })}
      />
      <OrderNotesToggle
        title="call_center"
        status={orderConfigurationStore.orderSettings.notes.smsEditOrder}
        label="Allow_customers_to_edit_order_details_through_SMS_payment_link"
        onChange={(status) => changeOrderNotes({ smsEditOrder: status })}
      />
      <OrderNotesToggle
        status={orderConfigurationStore.orderSettings.notes.is_cc_zone_orders}
        label="settings_order_config_cc_delivery_zones_toggle"
        onChange={(status) => changeOrderNotes({ is_cc_zone_orders: status })}
      />
    </div>
  );
});
